import React, { useEffect } from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import "../Investor/style/ScheduleView.css";
import CustomisedButton from "../../common/components/CustomisedButton";
import CloseIcon from "@mui/icons-material/Close";
import { callApi } from "../../common/api";

const ScheduleView = (props) => {
  const { Time, closeButton } = props;

  const formatDate = (date) => {
    const inputDate = new Date(date);

    const options = { day: "2-digit", month: "long", year: "numeric" };
    const formattedDate = inputDate.toLocaleString("en-US", options);

    return formattedDate;
  };

  const formatTimeRange = (startTime, endTime) => {
    const options = { hour: "numeric", minute: "2-digit", hour12: true };
    const formattedStartTime = new Date(startTime).toLocaleString("en-US", options);
    const formattedEndTime = new Date(endTime).toLocaleString("en-US", options);

    return `${formattedStartTime} to ${formattedEndTime}`;
  };


  return (
    <Box id="mainBox">
      <Box id="innerBox" sx={{ position: "relative", border: "1px solid grey" }}>
        <CloseIcon onClick={props.closeButton} sx={{ position: "absolute", backgroundColor: "black", color: "white", borderRadius: "10px", top: 10, right: 15, cursor: "pointer" }} />
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", mb: 2 }}>
            <img src="/Group.png" alt="Group Logo" style={{ height: "70px", width: "70px" }} />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ fontSize: "23px", color: "white", textAlign: "center", mb: 2 }}>
              Successful
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="white">Slot Book No</Typography>
          </Grid>
          <Grid item xs={6}>
            {/* <Typography color="white">{Time.id}</Typography> */}
            <Typography sx={{ width: "140px", display: "flex", justifyContent: "flex-end" }} color="white">{Time.id}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="white">Date</Typography>
          </Grid>
          <Grid item xs={6}>
            {/* <Typography color="white">{formatDate(Time.startTime)}</Typography> */}
            <Typography sx={{ width: "140px", display: "flex", justifyContent: "flex-end" }} color="white">{formatDate(Time.startTime)}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography color="white">Time</Typography>
          </Grid>
          <Grid item xs={6}>
            {/* <Typography color="white">{formatTimeRange(Time.startTime, Time.endTime)}</Typography> */}
            <Typography sx={{ width: "140px", display: "flex", justifyContent: "flex-end" }} color="white">{formatTimeRange(Time.startTime, Time.endTime)}</Typography>
          </Grid>

          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button
              onClick={props.closeButton}
              variant="contained"
              sx={{ width: "300px", borderRadius: "10px", color: "black", backgroundColor: "white" }}
            >
              Continue
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ScheduleView;
